import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Grid, Box,AppBar,Link} from '@material-ui/core';
import Login from "./login";
import InfoGraphics from "./infoGraphics";

import {BaseURL,candyTechURL} from "@project/shared/src/services/postData";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height:'100vh',
        backgroundColor:'#F6F7FF',
    },
    appBar: {
        top: 'auto',
        bottom: 0,
        height:40,
        backgroundColor:'#2f455a',
        paddingLeft:20,
        paddingTop:10,
        paddingRight:20,
    },
    title: {
        color:'white'

    },
}));

export default function SITELOGIN() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xl={8} lg={7} md={6} >
                    <Box display={{sm: 'none', xs: 'none',md:'block',lg:'block', xl:'block' }} >
                       <InfoGraphics/>
                    </Box>
                </Grid>
                <Grid item xl={4} lg={5} md={6} sm={12}  xs={12}>
                    <Box>
                        <Login/>
                    </Box>
                </Grid>
            </Grid>

            <AppBar position="fixed" className={classes.appBar}>
                <Box display="flex">
                    <Box flexGrow={1} fontWeight="fontWeightLight" color="lightGray">
                        <Link
                            component="button"
                            variant="body2"
                            onClick={() => {
                              window.location.href = `${BaseURL}`;
                            }}
                            color="inherit"
                        >
                            SyncOffice
                        </Link>


                    </Box>

                    <Box fontWeight="fontWeightLight" fontSize="fontSize" color="lightGray">
                        <Link
                            onClick={() => {
                               window.location.href = `${candyTechURL}`;
                            }}
                            color="inherit"
                            component="button"
                            variant="body2"
                        >
                        @ Powered by Candy Technologies Pvt Ltd
                        </Link>
                    </Box>
                </Box>

            </AppBar>
        </div>
    );
}
